import { PopoverBody, Box, Accordion } from '@chakra-ui/react';
import CssEditorColors from './CssEditorColors';
import CssEditorTextColors from './CssEditorTextColors';
import { scrollBarStyle } from '../../../utils/layoutConfig';
import CssEditorFontSelector from './CssEditorFontSelector';
import CssEditorGlobalVarSelector from './CssEditorGlobalVarSelector';

const batutaColors = [
	'--brand-color-primary-pure',
	'--brand-color-secondary-pure',
	'--cta-color-pure',
	'--support-color-1',
	'--support-color-2',
	'--support-color-3',
	'--support-color-4',
];
const feedbackColors = ['--feedback-color-success', '--feedback-color-warning', '--feedback-color-error'];
const CSSEditorInputs = () => {
	return (
		<PopoverBody p={2}>
			<Box h={'400px'} overflow={'auto'} sx={scrollBarStyle}>
				<Accordion allowMultiple allowToggle>
					<CssEditorColors editableVar={batutaColors} title={'Cores'} />
					<CssEditorColors editableVar={feedbackColors} title={'Cores Feedback'} />
					<CssEditorTextColors />
					<CssEditorFontSelector />
					<CssEditorGlobalVarSelector />
				</Accordion>
			</Box>
		</PopoverBody>
	);
};

export default CSSEditorInputs;
